import { render, staticRenderFns } from "./courseFile.vue?vue&type=template&id=5f4573ff&scoped=true"
import script from "./courseFile.vue?vue&type=script&lang=js"
export * from "./courseFile.vue?vue&type=script&lang=js"
import style0 from "./courseFile.vue?vue&type=style&index=0&id=5f4573ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4573ff",
  null
  
)

export default component.exports